import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Hide navigation on home page
  if (location.pathname === '/') {
    return null;
  }

  return (
    <nav className="navigation">
      <button 
        className={`menu-button ${isOpen ? 'open' : ''}`} 
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        <div className="menu-icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>
      <div className={`menu ${isOpen ? 'open' : ''}`}>
        <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
        <Link to="/menu" className={location.pathname === '/menu' ? 'active' : ''} onClick={() => setIsOpen(false)}>Menu</Link>
        <Link to="/catering" className={location.pathname === '/catering' ? 'active' : ''} onClick={() => setIsOpen(false)}>Catering</Link>
        <Link to="/gallery" className={location.pathname === '/gallery' ? 'active' : ''} onClick={() => setIsOpen(false)}>Gallery</Link>
        <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''} onClick={() => setIsOpen(false)}>Contact</Link>
      </div>
    </nav>
  );
};

export default Navigation;
